// @flow

import { useRef } from 'react'
import { useAction } from '@reatom/react'
import Webcam from 'react-webcam'
import { b64toBlob, b64toType } from '@bfg/utils/base64helper'
import { uploadImage } from '@bfg/atoms/FileUpload'
import { useGeneratorExperiment } from '@bfg/contexts/ExperimentsContext'

export const useWebcam = (parent: string, width: number, subscriberId: number) => {

  const ref = useRef<null | Webcam>(null)
  const algExperiment = useGeneratorExperiment()

  const takePic = useAction(
    () => {
      if (ref.current !== null) {
        const shot = ref.current.getScreenshot()
        const type = b64toType(shot)
        const blob = b64toBlob(shot)
        const file = new File([blob], 'userfile.jpg', { type: type })
        return uploadImage({ file: file, parent: parent, webcam: true, subscriberId, alg: algExperiment })
      }
    },
    [ref]
  )

  const videoConfig = {
    facingMode: 'user',
    width: width,
    height: width,
    aspectRatio: 1
  }

  return { ref, takePic, videoConfig }
}
